import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Flex, Modal, Spin, Tooltip, Typography } from "antd";
import { useForm } from "antd/es/form/Form";
import _ from "lodash";
import React, { useState } from "react";
import { ContentPartFilter } from "../../../../components/content-part/ContentPartFilter";
import { PageHeader } from "../../../../components/page-header";
import { EntTypeTransport } from "../../../../models/handBooks/typeTransport";
import { AddTypeTransportModal } from "./AddTypeTransportModal";
import { useTypeTransport } from "./useTypeTransport";
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import { EntTypeTransportFilter } from "../../../../models/filters/typeTransportFilter";
import { useLazyGetTransportTypeListQuery } from "../../../../redux/api/handBooksApi/transportTypesApi";
import { useGetDataOnScroll } from "../../../../components/getDataOnScrollProps/useGetDataOnScrollProps";
import { FilterTypeTransport } from "./FilterTypeTransport";

enum FormField {
  name,
  categoryIds,
}

export const TypeTransport = () => {

  const [form] = useForm();
  const { t } = useTranslation()
  const [modal, contextHolder] = Modal.useModal();
  const [selectedTransportType, setSelectedTransportType] = useState<EntTypeTransport>(new EntTypeTransport());
  const [showModal, setShowModal] = useState<boolean>(false);
  const { onAddTypeTransport, onDeleteTypeTransport, onEditTypeTransport } = useTypeTransport(modal, () => {
	searchHandleClick()
  })
  const [height, setHeight] = useState<number>(0);

  const [getData] = useLazyGetTransportTypeListQuery();
  const {
	fetching,
	data,
	access,
	filter,
	totalItems,
	setData,
	setFetching,
	setFilter,
	setCurrentPage
  } = useGetDataOnScroll<EntTypeTransport, EntTypeTransportFilter>({
	initialFilter: new EntTypeTransportFilter(),
	query: getData
  });

  const openAddModal = (item: EntTypeTransport) => {
	setSelectedTransportType(item);
	setShowModal(true);
  }

  const setEntityFromFields = (): EntTypeTransportFilter => {
	let item: EntTypeTransportFilter = _.clone(filter);
	item.name = form.getFieldValue(FormField.name) ?? null;
	item.categoryIds = form.getFieldValue(FormField.categoryIds) ?? null;
	item.page = 1;
	return item;
  }

  const clearFields = () => {
	form.setFields([
	  { name: FormField.name, value: null },
	  { name: FormField.categoryIds, value: null },
	]);
  }

  const searchHandleClick = () => {
	setFilter(setEntityFromFields());
	setData([]);
	setCurrentPage(0);
	setFetching(true);
  }

  const table = (
	<div style={ { maxHeight: `${ height }px`, overflow: 'auto' } }>
	  <table>
		<thead>
		<tr>
		  <th style={ { width: "40px" } }>#</th>
		  <th>{ t('general.nameKy') }</th>
		  <th>{ t('general.nameRu') }</th>
		  <th>{ t('mechanisation.transport.category') }</th>
		  <th style={ { width: "120px" } }></th>
		</tr>
		</thead>
		<tbody>
		{ fetching ?
		  <tr>
			<th colSpan={ 5 }>
			  <Spin spinning={ fetching } style={ {
				width: '100%',
				height: '180px',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center'
			  } }/>
			</th>
		  </tr>
		  : <></> }
		{ data.map((item, index) => (
		  <tr key={ item.id }>
			<td>{ ++index }</td>
			<td>{ item?.nameKy }</td>
			<td>{ item?.nameRu }</td>
			<td>{ i18n.language === 'ru' ? item.category?.nameRu : item.category?.nameKy }</td>
			<td>
			  <Flex gap="small">
				{ access && access.methodPut && (
				  <Tooltip title={ t('general.edit') }>
					<Button className='btn_edit' onClick={ () => {
					  openAddModal(item)
					} } type="primary" shape="circle" icon={ <EditOutlined/> }/>
				  </Tooltip>
				) }
				{ access && access.methodDelete && (
				  <Tooltip title={ t('general.delete') }>
					<Button className='btn_edit' danger onClick={ () => {
					  onDeleteTypeTransport(item)
					} } type="primary" shape="circle" icon={ <DeleteOutlined/> }/>
				  </Tooltip>
				) }
			  </Flex>
			</td>
		  </tr>
		)) }
		</tbody>
	  </table>
	</div>
  );
  return (
	<>
	  <PageHeader
		title={ t('titles.type_transport') }
		additionalInfo={
		  <Typography.Text style={ { marginBottom: '0.5em', display: 'block' } }
						   type="secondary">{ t('general.records_found') } { totalItems }</Typography.Text>
		}/>
	  { access && access.methodPost && (
		<Button type="primary" icon={ <PlusOutlined/> } onClick={ () => {
		  openAddModal(new EntTypeTransport)
		} }>
		  { t('handbooks.type_transport.add_type_transport') }
		</Button>
	  ) }
	  <ContentPartFilter
		filter={ <FilterTypeTransport
		  onSearch={ searchHandleClick }
		  onReset={ () => {
			clearFields();
			searchHandleClick()
		  } } formField={ FormField } form={ form }/> }
		setHeight={ setHeight }
		table={ table }
		width={ 800 }
	  />
	  <AddTypeTransportModal
		typeTransport={ selectedTransportType }
		show={ showModal }
		onHide={ () => {
		  setShowModal(false)
		} }
		onSubmit={ selectedTransportType.id !== 0 ? onEditTypeTransport : onAddTypeTransport }
	  />
	  { contextHolder }
	</>
  )
}
